/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RegenerationTextResultDto } from '../../models/regeneration-text-result-dto';
import { RequestChildAdolescentServiceRequestGenDto } from '../../models/request-child-adolescent-service-request-gen-dto';

export interface DocumentAiV2ControllerGenerateChildAdolescentServiceRequest$Params {
  centerId: string;
  type: 'user' | 'center';
      body: RequestChildAdolescentServiceRequestGenDto
}

export function documentAiV2ControllerGenerateChildAdolescentServiceRequest(http: HttpClient, rootUrl: string, params: DocumentAiV2ControllerGenerateChildAdolescentServiceRequest$Params, context?: HttpContext): Observable<StrictHttpResponse<RegenerationTextResultDto>> {
  const rb = new RequestBuilder(rootUrl, documentAiV2ControllerGenerateChildAdolescentServiceRequest.PATH, 'post');
  if (params) {
    rb.query('centerId', params.centerId, {});
    rb.query('type', params.type, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<RegenerationTextResultDto>;
    })
  );
}

documentAiV2ControllerGenerateChildAdolescentServiceRequest.PATH = '/api/document-ai-v2/child-adolescent-service-request-ai';
